export default __webpack_public_path__ + "static/media/Rubik-Light.b9897538.woff";